import React from "react";
import { ViewOrderDetailsCTA, ViewOrdersCTA } from "./ctas";
import { DamageMissingIA } from "./instantAnswersComponents/orders/DamageMissingIA";
import { isOrderReplaced } from "./utils/orderInfo";
export var damageMissing = function damageMissing(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2);
      }
    }
  };
};
var getAnswer = function getAnswer(context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return DAMAGE_MISSING_TITLE(context, strictLocalize);
    },
    getDescription: function getDescription() {
      return DAMAGE_MISSING_DESCRIPTION(context);
    }
  };
};
var DAMAGE_MISSING_TITLE = function DAMAGE_MISSING_TITLE(context, strictLocalize) {
  var isReplacement = isOrderReplaced(context);
  if (isReplacement) {
    return strictLocalize({
      id: "VmchwO",
      defaultMessage: [{
        "type": 0,
        "value": "O revendedor comunicou artigos em falta/danificados e solicitou substituições"
      }]
    });
  } else {
    return strictLocalize({
      id: "y7i9XU",
      defaultMessage: [{
        "type": 0,
        "value": "O revendedor comunicou artigos em falta/danificados"
      }]
    });
  }
};
var getPrimaryCTA = function getPrimaryCTA(context, strictLocalize) {
  var _context$brandOrder, _context$brandOrder$b;
  var brandOrderToken = (_context$brandOrder = context.brandOrder) === null || _context$brandOrder === void 0 ? void 0 : (_context$brandOrder$b = _context$brandOrder.brand_order) === null || _context$brandOrder$b === void 0 ? void 0 : _context$brandOrder$b.token;
  if (brandOrderToken) {
    return ViewOrderDetailsCTA(brandOrderToken, strictLocalize);
  }
  return ViewOrdersCTA(strictLocalize);
};
var DAMAGE_MISSING_DESCRIPTION = function DAMAGE_MISSING_DESCRIPTION(context) {
  return /*#__PURE__*/React.createElement(DamageMissingIA, {
    context: context
  });
};